const servermode = 'uat' // prod - Live | uat - test | uat = uatelopment
export default servermode
